var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB19D0Cba7Caca5D2Da234A859885E15D09D00Fa106Cea4702598366C599Dbda2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.5L7 1.5L13 7.5",
    stroke: "#424143",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB19D0Cba7Caca5D2Da234A859885E15D09D00Fa106Cea4702598366C599Dbda2);
export default __webpack_public_path__ + "static/media/b19d0cba7caca5d2da234a859885e15d09d00fa106cea4702598366c599dbda2.695b87b419cbf72a82f356ddb4b65337.svg";
export { ForwardRef as ReactComponent };